import React from "react";
import ContactDetails from "../../../_components/Contacts/ContactDetails";
import {
    getCustomerById, updateCustomer, createCustomer,
    getCustomerCompanyNames,
} from "../../../_services/contact.service";
import { isBusinessUnitUser, isSuperAdmin, canAccessAccounting } from '../../../utils/roleConstants';


export default function CustomerDetails() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // Keep detail editing aligned with the Customer list's exact writer policy.
    const viewOnly = !(isSuperAdmin(user) || isBusinessUnitUser(user) || canAccessAccounting(user));
    return (
        <ContactDetails
            type="Customer"
            fetchById={getCustomerById}
            updateItem={updateCustomer}
            createItem={createCustomer}
            fetchCompanyNames={getCustomerCompanyNames}
            viewOnly={viewOnly}
        />
    );
}